import React from 'react';
import styled, { css } from 'styled-components';
import { GetColor } from '../../style/color';
import type { BrandLogoProps } from '../src/logo/BrandLogoProps';

const VennText = () => {
  return (
    <path
      className="venn-logo-5"
      d="M88.1,20.1c-0.4-1-0.1-1.5,1-1.5h0.8c0.8,0,1.3,0.3,1.5,1l11.5,29.2c0.2,0.5,0.3,1,0.5,1.5
      c0.2,0.5,0.4,0.9,0.5,1.3c0.2,0.5,0.3,1,0.4,1.4h0.2c0.1-0.4,0.2-0.9,0.4-1.4c0.1-0.4,0.2-0.8,0.4-1.3c0.2-0.5,0.3-1,0.5-1.5
      l11.5-29.2c0.2-0.7,0.7-1,1.5-1h0.7c1.1,0,1.4,0.5,1,1.5l-14.1,36c-0.2,0.7-0.7,1-1.5,1h-0.9c-0.8,0-1.3-0.3-1.5-1L88.1,20.1z
      M123.5,37.9c0-3.2,0.5-6.1,1.5-8.6s2.4-4.6,4.1-6.3c1.7-1.7,3.8-3.1,6-3.9c2.3-0.9,4.6-1.4,7.1-1.4c2.5,0,4.8,0.4,6.7,1.3
      c2,0.9,3.6,2.1,4.9,3.7c1.3,1.6,2.3,3.5,3,5.8c0.7,2.3,1.1,4.8,1.1,7.6c0,0.4-0.1,0.7-0.4,1c-0.3,0.2-0.6,0.3-1,0.3h-29.7
      c0,2.8,0.4,5.3,1.3,7.5c0.9,2.2,2.1,4,3.5,5.6c1.5,1.5,3.3,2.6,5.2,3.4c2,0.8,4.1,1.2,6.4,1.2c1.3,0,2.6-0.1,3.7-0.4
      c1.1-0.3,2.2-0.6,3.1-1c0.9-0.4,1.7-0.8,2.4-1.3c0.7-0.5,1.3-0.9,1.7-1.2c0.7-0.6,1.3-0.5,1.8,0.2l0.5,0.6
      c0.5,0.6,0.4,1.2-0.3,1.7c-0.5,0.4-1.1,0.9-1.9,1.4c-0.8,0.5-1.7,1-2.8,1.5s-2.3,0.8-3.7,1.2c-1.3,0.4-2.8,0.5-4.4,0.5
      c-2.7,0-5.3-0.5-7.7-1.4c-2.4-1-4.5-2.3-6.3-4.1s-3.2-3.9-4.3-6.3C124,43.8,123.5,41,123.5,37.9z M154.6,34.3
      c-0.1-2.4-0.5-4.4-1.2-6.1c-0.7-1.7-1.6-3.1-2.7-4.2s-2.4-2-3.9-2.5c-1.4-0.6-3-0.8-4.6-0.8c-1.8,0-3.5,0.3-5.2,0.8
      s-3.2,1.4-4.6,2.6c-1.3,1.1-2.5,2.5-3.4,4.2c-0.9,1.7-1.6,3.7-1.9,5.9H154.6z M166.2,19.9c0-0.9,0.4-1.3,1.3-1.3h0.6
      c0.9,0,1.3,0.4,1.3,1.3v5.5c0,0.5,0,0.9-0.1,1.3c0,0.4,0,0.7-0.1,0.9c-0.1,0.3-0.1,0.6-0.2,0.9h0.2c0.3-0.9,0.9-2,1.7-3.2
      c0.9-1.2,2-2.4,3.3-3.5c1.4-1.1,3-2.1,4.9-2.9c1.9-0.8,4.1-1.2,6.5-1.2c2.5,0,4.6,0.4,6.2,1.1c1.6,0.7,3,1.7,3.9,3.1
      c1,1.3,1.6,2.9,2,4.7c0.4,1.9,0.6,3.9,0.6,6.2v23.1c0,0.9-0.4,1.3-1.3,1.3h-0.6c-0.9,0-1.3-0.4-1.3-1.3v-22c0-1.7-0.1-3.3-0.3-4.9
      c-0.2-1.6-0.6-3-1.2-4.2c-0.6-1.2-1.6-2.2-2.9-2.9c-1.2-0.7-2.9-1.1-5.1-1.1c-2.2,0-4.3,0.4-6.2,1.3c-2,0.8-3.7,2-5.2,3.5
      c-1.4,1.5-2.6,3.4-3.5,5.5c-0.9,2.1-1.3,4.3-1.3,6.8v17.9c0,0.9-0.4,1.3-1.3,1.3h-0.6c-0.9,0-1.3-0.4-1.3-1.3V19.9z M208.8,19.9
      c0-0.9,0.4-1.3,1.3-1.3h0.6c0.9,0,1.3,0.4,1.3,1.3v5.5c0,0.5,0,0.9-0.1,1.3c0,0.4,0,0.7-0.1,0.9c-0.1,0.3-0.1,0.6-0.2,0.9h0.2
      c0.3-0.9,0.9-2,1.7-3.2c0.9-1.2,2-2.4,3.3-3.5c1.4-1.1,3-2.1,4.9-2.9c1.9-0.8,4.1-1.2,6.5-1.2c2.5,0,4.6,0.4,6.2,1.1
      c1.6,0.7,3,1.7,3.9,3.1c1,1.3,1.6,2.9,2,4.7c0.4,1.9,0.6,3.9,0.6,6.2v23.1c0,0.9-0.4,1.3-1.3,1.3h-0.6c-0.9,0-1.3-0.4-1.3-1.3v-22
      c0-1.7-0.1-3.3-0.3-4.9c-0.2-1.6-0.6-3-1.2-4.2c-0.6-1.2-1.6-2.2-2.9-2.9c-1.2-0.7-2.9-1.1-5.1-1.1c-2.2,0-4.3,0.4-6.2,1.3
      c-2,0.8-3.7,2-5.2,3.5c-1.4,1.5-2.6,3.4-3.5,5.5c-0.9,2.1-1.3,4.3-1.3,6.8v17.9c0,0.9-0.4,1.3-1.3,1.3h-0.6
      c-0.9,0-1.3-0.4-1.3-1.3V19.9z"
    />
  );
};

const ByTwoSigma = () => {
  return (
    <>
      <VennText />
      <path
        className="venn-logo-5"
        d="M135.5,67.2c0-0.3,0.1-0.4,0.4-0.4h0.4c0.3,0,0.4,0.1,0.4,0.4v2.5c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2
      c0,0.1,0,0.1,0,0.1h0c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.1,0.4-0.3,0.6-0.4c0.3-0.1,0.6-0.2,0.9-0.2c0.4,0,0.8,0.1,1.1,0.2
      c0.3,0.2,0.6,0.4,0.8,0.7c0.2,0.3,0.4,0.6,0.5,1c0.1,0.4,0.2,0.8,0.2,1.3c0,0.5-0.1,0.9-0.2,1.3c-0.1,0.4-0.3,0.7-0.6,1
      c-0.2,0.3-0.5,0.5-0.9,0.6s-0.7,0.2-1.1,0.2c-0.4,0-0.7-0.1-0.9-0.2c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6h0
      c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3V75c0,0.2-0.1,0.4-0.4,0.4h-0.3c-0.3,0-0.4-0.1-0.4-0.4V67.2z M136.6,72.3c0,0.3,0,0.6,0.1,0.8
      c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.1,0.5,0.2,0.8,0.2c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4
      c0.2-0.2,0.3-0.4,0.4-0.7c0.1-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.6-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.3-0.3-0.6-0.4
      c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.3,0.4-0.4,0.7
      C136.6,71.6,136.6,71.9,136.6,72.3z M141.7,77c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0
      c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.4-0.6l0.3-0.7l-2.4-5.6c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.5
      c0.2,0,0.4,0.1,0.4,0.3l1.4,3.7c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0.1,0.3h0l0.1-0.2c0-0.1,0-0.1,0.1-0.2
      c0-0.1,0.1-0.2,0.1-0.3l1.4-3.7c0.1-0.2,0.2-0.3,0.4-0.3h0.4c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0,0.3l-2.7,6.7
      c-0.2,0.5-0.5,0.8-0.8,1.1c-0.3,0.2-0.7,0.4-1.2,0.4c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.2-0.2
      c0-0.1,0-0.2,0-0.3L141.7,77z"
      />
      <path className="venn-logo-5" d="M174.5,75.4v-7h-3v-1.5h7.4v1.5h-3v7H174.5z" />
      <path
        className="venn-logo-5"
        d="M188.9,66.9h1.5l-2.1,8.4H187l-1.9-5.9l-1.9,5.9h-1.3l-2.1-8.4h1.5l1.4,5.9l1.9-5.9h1.1l1.9,5.9L188.9,66.9z"
      />
      <path
        className="venn-logo-5"
        d="M195,75.5c-0.9,0-1.7-0.3-2.4-0.7c-0.7-0.5-1.3-1.1-1.6-1.9c-0.3-0.8-0.4-1.7-0.2-2.5
      c0.2-0.8,0.6-1.6,1.2-2.2c0.6-0.6,1.4-1,2.2-1.2c0.8-0.2,1.7-0.1,2.5,0.2c0.8,0.3,1.5,0.9,1.9,1.6c0.5,0.7,0.7,1.5,0.7,2.4
      c0,1.1-0.5,2.2-1.3,3.1C197.2,75,196.1,75.5,195,75.5z M192.2,71.1c0,0.5,0.2,1.1,0.5,1.5c0.3,0.5,0.7,0.8,1.2,1
      c0.5,0.2,1.1,0.3,1.6,0.2c0.5-0.1,1-0.4,1.4-0.8c0.4-0.4,0.7-0.9,0.8-1.4c0.1-0.5,0.1-1.1-0.2-1.6c-0.2-0.5-0.6-0.9-1-1.2
      c-0.5-0.3-1-0.5-1.5-0.5c-0.7,0-1.4,0.3-2,0.8C192.5,69.7,192.2,70.4,192.2,71.1z"
      />
      <path
        className="venn-logo-5"
        d="M206.3,75.5c-1.9,0-3.1-0.9-3.4-2.7h1.7c0.3,0.8,0.8,1.2,1.8,1.2c1,0,1.5-0.5,1.5-1c0-0.4-0.2-0.7-1-0.9
      l-1.5-0.3c-1.6-0.3-2.2-1-2.2-2.3c0-1.3,1.2-2.7,3.1-2.7c1.7,0,2.9,1,3.1,2.7h-1.5c-0.2-0.8-0.8-1.2-1.7-1.2c-1,0-1.5,0.5-1.5,1.1
      c0,0.5,0.3,0.8,1.1,0.9l1.6,0.3c1.5,0.3,2.1,1,2.1,2.2C209.6,74.4,208.3,75.5,206.3,75.5z"
      />
      <path className="venn-logo-5" d="M210.9,75.4v-8.4h1.5v8.4H210.9z" />
      <path
        className="venn-logo-5"
        d="M217.8,75.5c-0.6,0-1.1-0.1-1.7-0.3c-0.5-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.9-1-1.4c-0.2-0.5-0.3-1.1-0.3-1.7
      c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9c0.5-0.2,1.1-0.3,1.7-0.3c1.7,0,3.3,1,4,2.7H220
      c-0.2-0.4-0.6-0.6-1-0.8c-0.4-0.2-0.8-0.3-1.2-0.3c-0.5,0-1,0.1-1.4,0.4c-0.4,0.3-0.8,0.6-1,1.1c-0.2,0.4-0.4,0.9-0.3,1.4
      c0,0.5,0.2,1,0.5,1.4c0.3,0.4,0.7,0.8,1.1,1c0.4,0.2,1,0.3,1.5,0.3c0.5,0,1-0.2,1.4-0.5c0.4-0.3,0.7-0.7,0.9-1.1H218v-1.5h3.8v4.6
      h-1.3v-1.1C219.8,75.1,218.9,75.5,217.8,75.5z"
      />
      <path
        className="venn-logo-5"
        d="M227.2,75.4l-2.5-5.6v5.6h-1.5v-8.4h1.6l2.8,6l2.8-6h1.6v8.4h-1.5v-5.6l-2.5,5.6H227.2z"
      />
      <path
        className="venn-logo-5"
        d="M234.4,75.4h-1.6l3.6-8.4h1.1l3.6,8.4h-1.6l-0.6-1.5H235L234.4,75.4z M235.5,72.4h2.6l-1.3-3.2L235.5,72.4z"
      />
      <path
        className="venn-logo-5"
        d="M158.3,71.1c0.5-0.5,0.7-1,0.7-1.6c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6
      c-0.4,0.4-0.7,0.9-0.7,1.4h1.1c0-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.3,0.7-0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.5,0.3,0.7
      c0,0.3-0.1,0.6-0.4,0.9l-2.8,2.8v1h4.4v-1.1h-2.9L158.3,71.1z"
      />
      <path
        className="venn-logo-5"
        d="M163.5,70.2h0.9l0.9-0.9h-3.1c-1.6,0-2.8,1.1-2.8,2.5c0,0.7,0.3,1.3,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7
      c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.8C164.5,71.3,164.3,70.7,163.5,70.2z M162,73.3c-0.4,0-0.8-0.2-1.1-0.4
      c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.4,0.2-0.8,0.4-1.1c0.3-0.3,0.7-0.4,1.1-0.4c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3
      c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3
      C162.4,73.3,162.2,73.3,162,73.3z"
      />
      <path
        className="venn-logo-7"
        d="M163.5,71.8c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.2-1.1-0.4
      c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.4,0.2-0.8,0.4-1.1c0.3-0.3,0.7-0.4,1.1-0.4c0.4,0,0.8,0.2,1.1,0.4S163.5,71.4,163.5,71.8z
       M168.2,71.1l-1.1,1.1l-6.6,6.6l-1.1,1.1l-1.1-1.1l-6.6-6.6l-1.1-1.1l1.1-1.1l6.6-6.6l1.1-1.1l1.1,1.1l6.6,6.6L168.2,71.1z
       M159.1,74.3v-1.1h-2.9l2.1-2.1c0.5-0.5,0.7-1,0.7-1.6c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6
      c-0.4,0.4-0.7,0.9-0.7,1.4h1.1c0-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.3,0.7-0.2c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.5,0.3,0.7
      c0,0.3-0.1,0.6-0.4,0.9l-2.8,2.8v1L159.1,74.3z M163.5,70.2h0.9l0.9-0.9h-3.1c-1.6,0-2.8,1.1-2.8,2.5c0,0.7,0.3,1.3,0.7,1.8
      c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.3-0.3,1.8-0.7c0.5-0.5,0.7-1.1,0.7-1.8C164.5,71.3,164.3,70.7,163.5,70.2L163.5,70.2z"
      />
    </>
  );
};

export const BrandLogo = ({
  animateOnHover,
  isAnimated,
  isBackground,
  scaleToFit,
  showText,
  height,
}: BrandLogoProps) => {
  const logoHeight = height || (showText ? 47 : 30);
  const viewBoxValue = `0 0 ${showText ? 244 : 88} 80`;

  return (
    <StyledLogo
      animateOnHover={animateOnHover}
      isAnimated={isAnimated}
      height={logoHeight}
      width={scaleToFit ? (showText ? 3 * logoHeight : logoHeight) : showText ? 145 : 32}
      viewBox={viewBoxValue}
      shapeRendering="geometricPrecision"
      isBackground={isBackground}
    >
      <path className="venn-logo-3" d="M22.2,0H1.1l10.6,18.3h21.1L22.2,0z" />
      <path className="venn-logo-3" d="M77.6,18.3L88.2,0H67.1L56.5,18.3H77.6z" />
      <path className="venn-logo-2" d="M56.5,18.3L67.1,0H22.2l10.6,18.3H56.5z" />
      <path className="venn-logo-3" d="M55.2,57.1L44.6,38.9L34.1,57.1l10.5,18.3L55.2,57.1z" />
      <path className="venn-logo-2" d="M44.6,38.9L32.8,18.3H11.7l22.4,38.8L44.6,38.9z" />
      <path className="venn-logo-2" d="M44.6,38.9l10.6,18.3l22.4-38.8H56.5L44.6,38.9z" />
      <path className="venn-logo-4" d="M32.8,18.3l11.9,20.5l11.9-20.5H32.8z" />

      {showText && <ByTwoSigma />}
    </StyledLogo>
  );
};

export default BrandLogo;

const animateCss = css`
  path,
  .venn-logo-5,
  .venn-logo-8 {
    fill-opacity: 1;
    stroke: ${GetColor.White};
    stroke-width: 2;
    stroke-dasharray: 3319;
    stroke-dashoffset: 3319;
    animation: lines 5s forwards;
  }

  .venn-logo-2 {
    animation: logoTwoFill 4s infinite alternate;
  }

  .venn-logo-3 {
    animation: logoThreeFill 6s infinite alternate;
  }

  .venn-logo-4 {
    animation: logoFourFill 5s infinite alternate;
  }
`;

export const LogoColor = {
  Logo1: '#009AA6',
  Logo2: '#7DCECA',
  Logo3: '#CEF2ED',
  Logo4: '#00A5BD',
  Logo5: '#00CCCC',
};

export const UpdatedLogoColor = {
  Logo1: '#CEF2ED',
  Logo2: '#7DCECA',
  Logo3: '#9C61C1',
  Logo4: '#00A5BD',
};

const StyledLogo = styled.svg<{
  animateOnHover?: boolean;
  isAnimated?: boolean;
  isBackground?: boolean;
}>`
  .venn-logo-1 {
    fill: none;
  }

  .venn-logo-2 {
    fill: ${UpdatedLogoColor.Logo1};
  }

  .venn-logo-3 {
    fill: ${UpdatedLogoColor.Logo2};
  }

  .venn-logo-4 {
    fill: ${UpdatedLogoColor.Logo3};
  }

  .venn-logo-5,
  .venn-logo-8 {
    fill: ${GetColor.White};
  }

  .venn-logo-6 {
    clip-path: url(#clip-path);
  }

  .venn-logo-7 {
    fill: ${UpdatedLogoColor.Logo4};
  }

  .venn-logo-8 {
    font-size: 30px;
    font-family: ${(props) => props.theme.Typography.fontFamily};
    font-weight: 400;
    letter-spacing: -0.01em;
  }

  @keyframes lines {
    90% {
      stroke-dashoffset: 0;
      stroke-width: 2;
    }
    100% {
      stroke-dashoffset: 0;
      stroke-width: 2;
    }
  }

  @keyframes logoTwoFill {
    10% {
      fill: ${UpdatedLogoColor.Logo1};
    }
    50% {
      fill: ${UpdatedLogoColor.Logo3};
    }
    100% {
      fill: ${UpdatedLogoColor.Logo1};
    }
  }

  @keyframes logoThreeFill {
    15% {
      fill: ${UpdatedLogoColor.Logo2};
    }
    55% {
      fill: ${UpdatedLogoColor.Logo1};
    }
    100% {
      fill: ${UpdatedLogoColor.Logo2};
    }
  }

  @keyframes logoFourFill {
    5% {
      fill: ${UpdatedLogoColor.Logo3};
    }
    45% {
      fill: ${UpdatedLogoColor.Logo1};
    }
    100% {
      fill: ${UpdatedLogoColor.Logo3};
    }
  }
  ${({ animateOnHover, isAnimated }) =>
    isAnimated
      ? animateCss
      : animateOnHover
        ? css`
            &:hover {
              ${animateCss}
            }
          `
        : ''}

  ${({ isBackground }) =>
    isBackground
      ? ` opacity: 0.1;
  position: absolute;
  left: 50%;
  margin-left: -150px;
  top: 70px;`
      : ''}
`;
